import { BaseIndexRowModel } from "../base-index-row.model";

export interface SmsIndexRowModel extends BaseIndexRowModel {
  smsContent: string;
}
